import {
  asChildPropDef,
  dataListRootPropDefs as themesDataListRootPropDefs,
  dataListItemPropDefs as themesDataListItemPropDefs,
  dataListLabelPropDefs as themesDataListLabelPropDefs,
} from "@radix-ui/themes/props";
import type { PropDef } from "@radix-ui/themes/props";

export const dataListRootAs = ["dl", "div"] as const;
export const dataListRootPropDefs = {
  ...themesDataListRootPropDefs,
  as: { type: "enum", values: dataListRootAs, default: "dl" },
  ...asChildPropDef,
} satisfies typeof themesDataListRootPropDefs & {
  as: PropDef<(typeof dataListRootAs)[number]>;
};

export const dataListItemPropDefs = {
  ...themesDataListItemPropDefs,
  ...asChildPropDef,
} satisfies typeof themesDataListItemPropDefs;

export const dataListLabelAs = ["dt", "div"] as const;
export const dataListLabelPropDefs = {
  ...themesDataListLabelPropDefs,
  as: { type: "enum", values: dataListLabelAs, default: "dt" },
  ...asChildPropDef,
} satisfies typeof themesDataListLabelPropDefs & {
  as: PropDef<(typeof dataListLabelAs)[number]>;
};

export const dataListValueAs = ["dd", "div"] as const;
export const dataListValuePropDefs = {
  as: { type: "enum", values: dataListValueAs, default: "dd" },
  ...asChildPropDef,
} satisfies {
  as: PropDef<(typeof dataListValueAs)[number]>;
};
